export default __webpack_public_path__ + "static/media/all-phones.711a5d91.svg";